import {
  SHOPIFY_CUSTOMER_ID,
  SHOPIFY_RETAILERS_REDIRECT_URI,
  SHOPIFY_RETAILERS_FINISHED,
} from '../constants/shopifyTypes';

const initialState = {
  redirectUrl: null,
  shopifyCustomerAccountId: null,
};

const shopify = (state = initialState, action) => {
  switch (action.type) {
    case SHOPIFY_RETAILERS_REDIRECT_URI:
      return {
        ...state,
        redirectUrl: action.payload,
      };
    case SHOPIFY_RETAILERS_FINISHED:
      return {
        ...state,
        redirectUrl: null,
      };
    case SHOPIFY_CUSTOMER_ID:
      const { shopifyCustomerAccountId } = action.payload;
      return {
        ...state,
        shopifyCustomerAccountId,
      };
    default:
      return state;
  }
};

export default shopify;
